import {
  clientId, clientSecret,
  oauthBaseUrl
} from './config';

import {getRefreshToken} from './utils';

const TOKEN = 'token';

export default class TokenService {
  static findToken(username, password) {
    const form = new FormData();
    form.append('grant_type', 'password');
    form.append('client_id', clientId);
    form.append('client_secret', clientSecret);
    form.append('username', username);
    form.append('password', password);

    const init = {
      method: 'POST',
      body: form
    };

    return fetch(`${oauthBaseUrl}/${TOKEN}`, init)
      .then(response => {
        const json = response.json();
        if (!response.ok)
          return json.then(error => {throw error});
        return json;
      });
  }

  static refreshToken() {
    const form = new FormData();
    form.append('grant_type', 'refresh_token');
    form.append('client_id', clientId);
    form.append('client_secret', clientSecret);
    form.append('refresh_token', getRefreshToken());

    const init = {
      method: 'POST',
      body: form
    };

    return fetch(`${oauthBaseUrl}/${TOKEN}`, init)
      .then(response => response.json())
      .catch(error => { throw error })
      // .then(response => {
      //   const json = response.json();
      //   if (!response.ok)
      //     return json.then(error => {throw error});
      //   return json;
      // });
  }
}



// WEBPACK FOOTER //
// ./src/service/sfp/token-service.js